const SUCCESS_MESSAGES = {
  ADD_ATTRIBUTE: 'Attribute added successfully',
  EDIT_ATTRIBUTE: 'Attribute updated successfully',
  DELETE_ATTRIBUTE: 'Attribute deleted successfully',
  UPDATE_GLOBAL_MAPPING: 'Global Configuration successfully updated',
  BULK_UPDATE_SUBMITTED:
    'Mass Update request successfully submitted. You will be notified upon completion, kindly refresh the app to see the changes',
  ADD_ACTIVITY_TYPE: 'Custom activity type added successfully',
  EDIT_ACTIVITY_TYPE: 'Custom activity type updated successfully',

  ADD_CURRENCY: 'New Currency successfully added',
  MANAGE_CURRENCY: 'Exchange rates successfully saved',
  EDIT_EXCHANGE_RATES: 'Exchange rates successfully saved',
  UPDATE_DEFAULT_CURRENCY: 'Default currency successfully updated',

  ADD_STAGE: 'New Lifecycle stage successfully added',
  DELETE_STAGE: 'Lifecycle stage successfully deleted',
  CHANGE_DEFAULT_STAGE: 'Default lifecycle successfully updated',

  ADD_ORGANIZATION: 'Organization successfully created',
  EDIT_ORGANIZATION: 'Organization successfully updated',
  ARCHIVE_ORGANIZATION: 'Organization archived successfully',
  RESTORE_ORGANIZATION: 'Organization restored successfully',
  CHURN_ORGANIZATION: 'Organization churn status changed successfully',

  ADD_ACCOUNT: 'Account successfully created',
  EDIT_ACCOUNT: 'Account successfully updated',
  ARCHIVE_ACCOUNT: 'Account archived successfully',
  RESTORE_ACCOUNT: 'Account restored successfully',
  CHURN_ACCOUNT: 'Account churn status changed successfully',

  ADD_CONTACT: 'Contact successfully created',
  EDIT_CONTACT: 'Contact successfully updated',
  PORTAL_ACCESS_ENABLED: 'Connect access provided successfully',
  PORTAL_ACCESS_DISABLED: 'Connect access disabled successfully',
  ARCHIVE_CONTACT: 'Contact archived successfully',
  RESTORE_CONTACT: 'Contact restored successfully',

  ADD_PIPELINE: 'Pipeline successfully added',
  EDIT_PIPELINE: 'Pipeline successfully updated',
  ARCHIVE_PIPELINE: 'Pipeline archived successfully',
  RESTORE_PIPELINE: 'Pipeline restored successfully',

  MOVE_ACCOUNT: 'Account moved successfully',
  MOVE_LINKED_ENTITIES: 'Linked Entities moved successfully',

  ADD_ACTIVITY: 'Activity successfully logged',
  ADD_NOTE: 'Note successfully logged',
  ADD_CSM_PULSE: 'Pulse successfully marked',
  ADD_TASK: 'Task added successfully',
  SEND_EMAIL: 'Email sent successfully',
  UPLOAD_FILE: 'Files uploaded successfully',

  UPDATE_ACTIVITY: 'Activity successfully updated',
  UPDATE_NOTE: 'Note successfully updated',
  UPDATE_PULSE: 'Pulse successfully updated',
  UPDATE_FILE: 'File successfully updated',
  UPDATE_CSM_PULSE: 'Pulse successfully updated',
  REPLY_EMAIL: 'Email sent successfully',

  DELETE_ACTIVITY: 'Activity successfully deleted',
  BOOKMARK_Activity: 'Activity bookmarked successfully',
  REMOVE_BOOKMARK_Activity: 'Activity bookmark removed successfully',
  DELETE_NOTE: 'Note successfully deleted',
  BOOKMARK_NOTE: 'Note bookmarked successfully',
  REMOVE_BOOKMARK_NOTE: 'Note bookmark removed successfully',
  DELETE_CSM_PULSE: 'Pulse successfully deleted',
  BOOKMARK_CSM_PULSE: 'Pulse bookmarked successfully',
  REMOVE_BOOKMARK_CSM_PULSE: 'Pulse bookmark removed successfully',
  DELETE_FILE: 'File successfully deleted',
  BOOKMARK_FILE: 'File bookmarked successfully',
  REMOVE_BOOKMARK_FILE: 'File bookmark removed successfully',

  ADD_EDIT_STAT_BAR: 'Stat Bar settings successfully saved',

  UPDATE_HEALTH_SCORE: 'Health Score settings successfully saved',

  INVITE_USER: 'Invitations successfully sent',
  EDIT_INFO: 'User details successfully updated',
  DEACTIVATE_USER: 'User deactivated successfully',
  CHANGE_USER_ROLE: 'User role successfully changed',
  RESEND_INVITATION: 'Invitation successfully resent',
  REVOKE_INVITATION: 'Invitation revoked successfully',
  REACTIVATE_USER: 'User reactivated successfully',
  DISABLE_USER_MFA: 'User 2FA deactivated',

  CREATE_EMAIL_SIGNATURE: 'Email signature added successfully',
  UPDATE_EMAIL_SIGNATURE: 'Email signature updated successfully',
  DELETE_EMAIL_SIGNATURE: 'Email signature removed successfully',

  IMAGE_UPLOAD: 'Image successfully updated',

  SAVE_SEGMENT: 'Segment successfully saved',

  CREATE_PROCESS_REQUEST: 'Request successfully submitted',

  // TASKS
  ARCHIVE_TASK: 'Task(s) successfully archived',
  COMPLETE_TASK: 'Task(s) successfully completed',
  RESOLVE_TASK: 'Task(s) successfully marked as resolved',
  MARK_IN_PROGRESS_TASK: 'Task(s) successfully marked as in progress',
  REASSIGN_TASK: 'Task(s) successfully re-assigned to new user',
  CREATE_TASK: 'Task successfully created',
  UPDATE_TASK: 'Task successfully updated',
  LOG_TIME: 'Time logged successfully',
  DELETE_WORK_LOG: 'Work log successfully deleted',
  BOOKMARK_TASK: 'Task bookmarked successfully',
  REMOVE_BOOKMARK_TASK: 'Task bookmark removed successfully',

  // PLAYBOOK TEMPLATES
  ARCHIVE_PLAYBOOK_TEMPLATE: 'Playbook successfully archived',
  SET_INACTIVE_PLAYBOOK_TEMPLATE: 'Playbook successfully set as inactive',
  SET_ACTIVE_PLAYBOOK_TEMPLATE: 'Playbook successfully set as active',
  CREATE_PLAYBOOK_TEMPLATE: 'Playbook successfully created',
  UPDATE_PLAYBOOK_TEMPLATE: 'Playbook successfully updated',
  APPLY_PLAYBOOK_TEMPLATE: 'Playbook successfully applied',

  // PLAYBOOK INSTANCES / APPLIED PLAYBOOKS
  COMPLETE_PLAYBOOK_INSTANCE: 'Applied Playbook successfully completed',
  MARK_IN_PROGRESS_PLAYBOOK_INSTANCE:
    'Applied Playbook successfully marked as in progress',
  ARCHIVE_PLAYBOOK_INSTANCE: 'Applied Playbook successfully archived',
  UPDATE_PLAYBOOK_INSTANCE: 'Applied Playbook successfully updated',

  // SCENARIOS
  CREATE_SCENARIO: 'Scenario created successfully',
  UPDATE_SCENARIO: 'Scenario updated successfully',
  ARCHIVE_SCENARIO: 'Scenario archived successfully',
  DELETE_SCENARIO: 'Scenario deleted successfully',
  ACTIVATE_SCENARIO: 'Scenario activated successfully',
  DEACTIVATE_SCENARIO: 'Scenario deactivated successfully',

  // Notifications
  SAVE_NOTIFICATION_SETTINGS: 'Notification settings successfully updated',

  // WEBHOOKS
  CREATE_WEBHOOK: 'Webhook created successfully',
  EDIT_WEBHOOK: 'Webhook updated successfully',
  ACTIVATE_WEBHOOK: 'Webhook activated successfully',
  DEACTIVATE_WEBHOOK: 'Webhook deactivated successfully',
  DELETE_WEBHOOK: 'Webhook deleted successfully',

  // SURVEYS
  CREATE_SURVEY: 'Survey created successfully',
  EDIT_SURVEY: 'Survey updated successfully',
  PAUSE_SURVEY: 'Survey paused successfully',
  DEACTIVATE_SURVEY: 'Survey deactivated successfully',
  PUBLISH_SURVEY: 'Survey published successfully',
  SEND_SURVEY_EMAIL: 'Emails will be sent to the selected recipients shortly',
  RESUME_SURVEY: 'Survey resumed successfully',
  DELETE_SURVEY: 'Survey deleted successfully',
  DELETE_SURVEY_RESPONSE: 'Survey response deleted successfully',

  // SUCCESS PLANS CREATION
  ADD_SUCCESS_PLAN: 'Success plan created successfully',
  EDIT_SUCCESS_PLAN: 'Success plan updated successfully',
  COMPLETE_SUCCESS_PLAN: 'Success plan completed successfully',
  IN_PROGRESS_SUCCESS_PLAN: 'Success plan marked in progress successfully',
  DUPLICATE_SUCCESS_PLAN: 'Success plan duplicated successfully',
  ARCHIVE_SUCCESS_PLAN: 'Success plan archived successfully',

  // SUCCESS PLANS MILESTONE
  ADD_SUCCESS_PLAN_MILESTONE: 'Success-plan milestone created successfully',
  EDIT_SUCCESS_PLAN_MILESTONE: 'Success-plan milestone updated successfully',
  COMPLETE_SUCCESS_PLAN_MILESTONE:
    'Success-plan milestone completed successfully',
  IN_PROGRESS_SUCCESS_PLAN_MILESTONE:
    'Success-plan milestone marked in progress successfully',
  ARCHIVE_SUCCESS_PLAN_MILESTONE:
    'Success-plan milestone archived successfully',

  // SUCCESS PLANS KPI
  ADD_SUCCESS_PLAN_KPI: 'Success-plan KPI created successfully',
  EDIT_SUCCESS_PLAN_KPI: 'Success-plan KPI updated successfully',
  ARCHIVE_SUCCESS_PLAN_KPI: 'Success-plan KPI archived successfully',

  // FILTERED VIEWS
  CREATE_FILTERED_VIEW: 'Filtered view created successfully',
  UPDATE_FILTERED_VIEW: 'Filtered view updated successfully',
  DELETE_FILTERED_VIEW: 'Filtered view deleted successfully',

  // EMAIL TEMPLATE
  CREATE_EMAIL_TEMPLATE: 'Email Template created successfully',
  UPDATE_EMAIL_TEMPLATE: 'Email Template updated successfully',
  DELETE_EMAIL_TEMPLATE: 'Email Template deleted successfully',

  // Unsubscription
  CREATE_UN_SUBSCRIPTION_CATEGORY:
    'Unsubscription Category created successfully',
  UPDATE_UN_SUBSCRIPTION_CATEGORY:
    'Unsubscription Category updated successfully',
  DELETE_UN_SUBSCRIPTION_CATEGORY:
    'Unsubscription Category deleted successfully',
  IN_ACTIVE_UN_SUBSCRIPTION_CATEGORY:
    'Unsubscription Category Inactivated successfully',
  ACTIVE_UN_SUBSCRIPTION_CATEGORY:
    'Unsubscription Category Activated successfully',

  ADD_COMMENT: 'Comment added successfully',
  UPDATE_COMMENT: 'Comment updated successfully',
  DELETE_COMMENT: 'Comment deleted successfully',

  // GLOBAL PREST
  GLOBAL_PRESET: 'Global Presets saved successfully',

  // SuccessPlan templates
  CREATE_KPI_TEMPLATE: 'KPI Template created successfully',
  UPDATE_KPI_TEMPLATE: 'KPI Template updated successfully',
  ARCHIVE_KPI_TEMPLATE: 'KPI Template archived successfully',
  CREATE_MILESTONE_TEMPLATE: 'Milestone Template created successfully',
  UPDATE_MILESTONE_TEMPLATE: 'Milestone Template updated successfully',
  ARCHIVE_MILESTONE_TEMPLATE: 'Milestone Template archived successfully',
};

export default SUCCESS_MESSAGES;
